var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detection-control-wrap"},[_c('start-button',{attrs:{"loading":_vm.loading,"status":_vm.status},on:{"switch":_vm.emitStart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }